import { axiosClient } from '../../../../utils/axiosClient';
import { ApiResponse, makeApiRequest } from '../../../utils';
import { AuthEndpoints } from './authEndpoints';
import {
    ActivateDonorEmailRequest,
    ActivateDonorProfileRequest,
    FacebookLoginRequest,
    LoginRequest,
    ResendActivateEmailRequest,
    UserSignupRequest,
} from './requests';
import {
    ActivateDonorEmailResponse,
    ActivateDonorProfileResponse,
    AppMigrateResponse,
    FacebookLoginResponse,
    LoginTypesResponse,
    LoginResponse,
    ResendActivateEmailResponse,
    SignupResponse,
} from './response';

export class AuthService {
    public async getAppMigrate(
        data: string,
    ): Promise<ApiResponse<AppMigrateResponse>> {
        const url = AuthEndpoints.appMigrate();
        const httpRequest = axiosClient.post(
            url,
            data ? { migrationJsonString: data } : undefined,
        );
        const result = await makeApiRequest<AppMigrateResponse>(httpRequest);
        return result;
    }

    public async loginByEmail(
        payload: LoginRequest,
    ): Promise<ApiResponse<LoginResponse>> {
        const url = AuthEndpoints.login();
        const httpRequest = axiosClient.post(url, payload);
        const result = await makeApiRequest<LoginResponse>(httpRequest);
        return result;
    }

    public async getLoginTypes(
        email: string,
        token?: string,
    ): Promise<ApiResponse<LoginTypesResponse>> {
        const url = AuthEndpoints.getLoginTypes(email, token);
        const httpRequest = axiosClient.get(url);
        const result = await makeApiRequest<LoginTypesResponse>(httpRequest);
        return result;
    }

    public async activateDonorProfile(
        payload: ActivateDonorProfileRequest,
    ): Promise<ApiResponse<ActivateDonorProfileResponse>> {
        const url = AuthEndpoints.activateDonorProfile();
        const httpRequest = axiosClient.post(url, payload);
        const result =
            await makeApiRequest<ActivateDonorProfileResponse>(httpRequest);
        return result;
    }

    public async resendActivateEmail(
        payload: ResendActivateEmailRequest,
    ): Promise<ApiResponse<ResendActivateEmailResponse>> {
        const url = AuthEndpoints.resendActivateEmail();
        const httpRequest = axiosClient.post(url, payload);
        const result =
            await makeApiRequest<ResendActivateEmailResponse>(httpRequest);
        return result;
    }

    public async activateDonorEmail(
        payload: ActivateDonorEmailRequest,
    ): Promise<ApiResponse<ActivateDonorEmailResponse>> {
        const url = AuthEndpoints.activateDonorEmail();
        const httpRequest = axiosClient.post(url, payload);
        const result =
            await makeApiRequest<ActivateDonorEmailResponse>(httpRequest);
        return result;
    }

    public async loginByFacebook(
        payload: FacebookLoginRequest,
    ): Promise<ApiResponse<FacebookLoginResponse>> {
        const url = AuthEndpoints.facebookLoginRequest();
        const httpRequest = axiosClient.post(url, payload);
        const result = await makeApiRequest<FacebookLoginResponse>(httpRequest);
        return result;
    }

    public async userSetPassword(
        password: string,
        token: string,
        email?: string,
    ): Promise<ApiResponse<unknown>> {
        const url = AuthEndpoints.userSetPassword();
        const httpRequest = axiosClient.post(url, {
            email,
            code: token,
            newPassword: password,
        });
        const result = await makeApiRequest<unknown>(httpRequest);
        return result;
    }

    public async userSignup(
        user: UserSignupRequest,
        password: string,
        captchaToken: string | undefined,
    ): Promise<ApiResponse<SignupResponse>> {
        const url = AuthEndpoints.userSignup();
        const httpRequest = axiosClient.post(url, {
            password: password,
            emailAddress: user.email,
            name: user.name,
            captchaToken,
            verification: captchaToken,
        });
        const result = await makeApiRequest<SignupResponse>(httpRequest);
        return result;
    }

    public async requestPasswordReset(
        email: string,
    ): Promise<ApiResponse<unknown>> {
        const url = AuthEndpoints.passwordReset();
        const httpRequest = axiosClient.post(url, {
            id: 'donorResetPassword',
            emailAddress: email,
        });
        const result = await makeApiRequest(httpRequest);
        return result;
    }
}
